"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiply = void 0;
/**
 * Sex fata field is either male or female
 * @param data
 * @param date_format
 */
function multiply(data, multiplier) {
    if (typeof data === 'string') {
        return parseFloat(data) * multiplier;
    }
    else {
        return data * multiplier;
    }
}
exports.multiply = multiply;
